"use client"

import { useEffect } from "react"
import "./partnerStyle.css"

export default function ProfileDialog({ open, onOpenChange, profile, title = "Profile" }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onOpenChange(false)
    }
    if (open) window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [open, onOpenChange])

  const rows = [
    { label: "Name", value: profile?.name || profile?.username },
    { label: "Email", value: profile?.email },
    { label: "Company", value: profile?.mainUserCompany || profile?.company_name },
    { label: "GSTIN", value: profile?.mainUserGST || profile?.gstin },
    { label: "PAN", value: profile?.mainUserPAN || profile?.pan },
  ].filter((r) => r.value)

  if (!open) return null

  return (
    <div
      className="ps-dialog-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ps-dialog-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onOpenChange(false)
      }}
    >
      <div className="ps-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="ps-dialog-header">
          <h2 id="ps-dialog-title" className="ps-title">
            {title}
          </h2>
          <p className="ps-subtle">Your profile details from profileDashboard.</p>
        </div>
        <div className="ps-dialog-body">
          {rows.length === 0 ? (
            <p className="ps-muted">No profile data found.</p>
          ) : (
            <dl className="ps-stack">
              {rows.map((r) => (
                <div key={r.label} className="ps-grid" style={{ gridTemplateColumns: "120px 1fr", gap: "0.5rem" }}>
                  <dt className="ps-subtle">{r.label}</dt>
                  <dd
                    className="ps-w-full"
                    style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                  >
                    {r.value}
                  </dd>
                </div>
              ))}
            </dl>
          )}
        </div>
        <div className="ps-dialog-actions">
          <button type="button" className="ps-btn ps-btn-ghost" onClick={() => onOpenChange(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
